import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

export default function Dashboard() {
  const [joinCode, setJoinCode] = useState("");
  const navigate = useNavigate();

  const createRoom = async () => {
    const docRef = await addDoc(collection(db, "rooms"), {
      users: [],
      ready: false
    });
    navigate(`/room/${docRef.id}`);
  };

  const joinRoom = () => {
    if (joinCode.trim()) {
      navigate(`/room/${joinCode}`);
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h2>به داشبورد خوش آمدید</h2>
      <button onClick={createRoom}>ساخت اتاق جدید</button>
      <div>
        <input
          type="text"
          placeholder="کد اتاق"
          value={joinCode}
          onChange={(e) => setJoinCode(e.target.value)}
        />
        <button onClick={joinRoom}>ورود به اتاق</button>
      </div>
    </div>
  );
}

